import React from 'react'

const useSiteWidth = () => {
	const [siteWidth, setSiteWidth] = React.useState<number>(0)

	React.useEffect(() => {
		if (!siteWidth) setSiteWidth(window.innerWidth)

		window.addEventListener('resize', () => setSiteWidth(window.innerWidth))
	}, [])

	return siteWidth
}

export default useSiteWidth
